
import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn} from '@angular/forms';

@Directive({
    selector: '[priceCalculationsValidator]',
    providers: [
      {
        provide: NG_VALIDATORS,
        useExisting: PriceCalculationsValidator,
        multi: true,
      },
    ],
    standalone: true,
  })
export class PriceCalculationsValidator implements Validator {

    validate(control: AbstractControl): ValidationErrors | null {
        return priceCalculationValidationFn(control);
    }
}

export const priceCalculationValidationFn: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    const netPrice = parseFloat(control.get('netAmount')?.value);
    const taxRate = control.get('taxRate')?.value;
    const taxAmount = parseFloat(control.get('taxamount')?.value);
    const grossAmount = parseFloat(control.get('grossamount')?.value);

    if( taxRate != undefined && taxRate.rate != undefined && (Math.abs(grossAmount - netPrice - netPrice * taxRate.rate/100) > 1e-6 || Math.abs(taxAmount - netPrice * taxRate.rate / 100 ) > 1e-6)){
        return { wrongCalculations: true };
    }
    return null;
  };